import BusinessInfoTabComponent from './BusinessInfoTab';

export const BusinessInfoTab = BusinessInfoTabComponent;
